export default class StickyHeader {
    constructor(elem, APP) {
        this.elem = elem
        this.headerHeight = '60px'
        this.nav = this.elem
        this.navTop = this.nav.offsetTop
    }

    debounceOptimize(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    
    stickyNavigation() {
      let setSticky = this.debounceOptimize(() => {
        console.log('navTop = ' + this.navTop);
        console.log('scrollY = ' + window.scrollY);
      
        
        if (window.scrollY >= this.navTop) {
          // nav offsetHeight = height of nav
        //   document.body.style.paddingTop = this.nav.offsetHeight + 'px';
          document.body.classList.add('fixed-nav');
        } else {
        //   document.body.style.paddingTop = 0;
          document.body.classList.remove('fixed-nav');
        }
      }, 250)
      window.addEventListener('scroll', setSticky);
    }
    
    
    
    init() {
        this.debounceOptimize()
        this.stickyNavigation()
    }
}